import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        flexDirection: 'column',
      },
      '& .slider': {
        position: 'absolute',
        top: '100%',
        right: 0,
        transition: '0.5s',
        '& button': {
          minWidth: 140,
        },
      },
      '&:hover': {
        '& .slider': {
          top: 12,
          transition: '0.5s',
        },
      },
      '& .float-right': {
        position: 'absolute',
        top: 12,
        right: 0,
        '& button': {
          minWidth: 140,
        },
      },
    },
    meta: {
      '& strong': {
        margin: `0 ${theme.spacing(1)}`,
        color: theme.palette.grey[700],
      },
    },
    leftColumn: {
      flex: '0 1 auto',
      paddingRight: 12,
      minWidth: 280,
      minHeight: 48,
      [theme.breakpoints.down('md')]: {
        minWidth: 'unset',
        width: '100%',
      },
    },
    rightColumn: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      columnGap: '10px',
      [theme.breakpoints.down('md')]: {
        flex: 'unset',
        flexDirection: 'column',
        rowGap: theme.spacing(0.5),
      },
    },
    resources: {
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    greyBox: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      width: '120px',
      height: '40px',
      borderRadius: '5px',
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[900],
      [theme.breakpoints.down('sm')]: {
        flex: 1,
      },
      '& p:first-child': {
        flex: '1 1 100%',
      },
      '& p:last-child': {
        flex: '0 1 24px',
        display: 'block',
      },
      '& svg': {
        flex: '0 1 24px',
        color: theme.palette.grey[700],
      },
    },
    squareButton: {
      padding: 0,
      borderRadius: 8,
      minWidth: 42,
    },
    responseButtons: {
      right: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(2),
      },
    },
  };
});

export default useStyles;
